module.exports = __webpack_public_path__ + "static/media/quote-mobile.b2df2928.svg";